import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

export default function Cart() {
  const { cart, dispatch, total } = useCart();

  // Grouper par stand
  const stands = {};
  cart.items.forEach(item => {
    const key = item.stand_nom || 'Autre';
    if (!stands[key]) stands[key] = [];
    stands[key].push(item);
  });

  return (
    <div className="min-h-screen bg-[#FEFCF8]">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#F3DFC0] shadow-sm">
        <div className="max-w-lg mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/order" className="text-[#8B7355] hover:text-[#332A1C] transition-colors">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </Link>
          <h1 className="font-serif font-bold text-xl text-[#332A1C]">
            Mon panier
          </h1>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-4 py-6">
        {cart.items.length === 0 ? (
          /* Empty Cart State */
          <div className="text-center py-24">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#FDF6EC] border border-[#F3DFC0] flex items-center justify-center">
              <svg className="w-9 h-9 text-[#C4673D]/50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </div>
            <p className="text-[#332A1C] font-serif text-xl mb-1">Votre panier est vide</p>
            <p className="text-[#8B7355] text-sm mb-6">Ajoutez des articles depuis les stands</p>
            <Link
              to="/order"
              className="inline-block px-6 py-2.5 bg-[#C4673D] text-white rounded-full font-medium text-sm hover:bg-[#A8532E] transition-colors shadow-sm"
            >
              Parcourir les stands
            </Link>
          </div>
        ) : (
          <>
            {/* Items grouped by stand */}
            {Object.entries(stands).map(([standName, items]) => (
              <div key={standName} className="mb-6">
                <div className="mb-3">
                  <h2 className="font-serif text-lg text-[#332A1C] mb-1.5">
                    {standName}
                  </h2>
                  <div className="w-10 h-0.5 bg-[#C4673D]/30 rounded-full" />
                </div>
                <div className="space-y-2">
                  {items.map(item => (
                    <div
                      key={item.product_id}
                      className="bg-white rounded-2xl border border-[#F3DFC0]/60 p-4 flex items-center justify-between gap-3 shadow-sm"
                    >
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-[#332A1C]">{item.nom}</p>
                        <p className="text-sm text-[#8B7355] mt-0.5">
                          {item.prix.toFixed(2)} &euro; / unit&eacute;
                        </p>
                      </div>

                      {/* Quantity Controls */}
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => dispatch({ type: 'UPDATE_QTY', product_id: item.product_id, quantite: item.quantite - 1 })}
                          className="w-8 h-8 rounded-full border border-[#E2D1B8] text-[#8B7355] font-bold flex items-center justify-center hover:border-[#C4673D] hover:text-[#C4673D] transition-colors active:scale-95"
                        >
                          &minus;
                        </button>
                        <span className="w-6 text-center font-medium text-[#332A1C] tabular-nums">
                          {item.quantite}
                        </span>
                        <button
                          onClick={() => dispatch({ type: 'UPDATE_QTY', product_id: item.product_id, quantite: item.quantite + 1 })}
                          className="w-8 h-8 rounded-full border border-[#E2D1B8] text-[#8B7355] font-bold flex items-center justify-center hover:border-[#C4673D] hover:text-[#C4673D] transition-colors active:scale-95"
                        >
                          +
                        </button>
                      </div>

                      {/* Subtotal */}
                      <p className="font-bold text-[#332A1C] w-18 text-right tabular-nums">
                        {(item.prix * item.quantite).toFixed(2)}&nbsp;&euro;
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Total Section */}
            <div className="bg-white rounded-2xl border border-[#F3DFC0]/60 p-5 mt-6 shadow-sm">
              <div className="flex justify-between items-center">
                <span className="font-serif text-lg text-[#332A1C]">
                  Total
                </span>
                <span className="text-[#C4673D] font-bold text-2xl font-serif tabular-nums">
                  {total.toFixed(2)} &euro;
                </span>
              </div>
            </div>

            {/* Validate Button */}
            <Link
              to="/checkout"
              className="block mt-6 bg-[#C4673D] text-white text-center font-semibold py-4 rounded-xl text-lg hover:bg-[#A8532E] active:scale-[0.98] transition-all shadow-sm"
            >
              Valider la commande
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
